// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__3yksd","btn_disabled":"Button_btn_disabled__t10FB"};